import { Component, ChangeDetectionStrategy, Input } from '@angular/core';
import { BannerModel } from '@shared/models';
import { ButtonComponent } from '../../../button/button.component';
import { SizePipe } from '@shared/pipes/size.pipe';

@Component({
    selector: 'app-slide',
    templateUrl: './slide.component.html',
    styleUrls: ['./slide.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [ButtonComponent, SizePipe],
})
export class SlideComponent {
    @Input({ required: true }) banner!: BannerModel;
    @Input({ required: true }) fullwidth!: boolean;
}
